module.exports = __webpack_public_path__ + "static/media/estate-planning.cd048130.png";